export const cleanInputs = () => {
    document.getElementById('product_ref').value = '';
    document.getElementById('product_description').value = '';
    document.getElementById('product_price_mt').value = 0;
    document.getElementById('product_price_kg').value = 0;
}

export const buildCreateProductBody = (company) => {
    return {
        ref: document.getElementById('product_ref').value,
        description: document.getElementById('product_description').value,
        price_mt: document.getElementById('product_price_mt').value,
        price_kg: document.getElementById('product_price_kg').value,
        company
    }
}

export const validateCreateProduct = (body) => {
    if(body.ref === null || body.ref === ''){
        throw new Error('Referencia vacía');
    }

    if(body.price_mt === null || body.price_mt === ''){
        throw new Error('Precio vacío');
    }

    if(isNaN(body.price_mt.replaceAll(" ","") || body.price_mt.includes('-'))){
        throw new Error('Precio no es valor numérico positivo');
    }

    if(body.price_mt < 0){
        throw new Error('Precio no es valor numérico positivo ');
    }

    if(body.price_kg === null || body.price_kg === ''){
        throw new Error('Precio vacío');
    }

    if(isNaN(body.price_kg.replaceAll(" ","") || body.price_kg.includes('-'))){
        throw new Error('Precio no es valor numérico positivo');
    }

    if(body.price_kg < 0){
        throw new Error('Precio no es valor numérico positivo ');
    }

    if((body.price_mt === 0 || body.price_mt === '0') && (body.price_kg === 0 || body.price_kg === '0')){
        throw new Error('Los dos precios son cero');
    }

    if(body.company === null || body.company === ''){
        throw new Error('Empresa vacía');
    }
}